import { ApiGroupModel } from './group-sidebar.component';

export const MAX_SUBGROUPS = 5;

export class GroupSidebarListItemController {
    public isCollapsed = false;
    public subgroupsOpen = false;

    public flatlist!: boolean;
    public addButton!: boolean;

    public subgroups!: ApiGroupModel[];
    private _filter!: string;
    private _group!: ApiGroupModel;

    set filter(value: string) {
        this._filter = value;
        this.isCollapsed = false;
    }

    get filter() {
        return this._filter;
    }

    get subgroupsOverLimit() {
        return (this._group.subgroups || []).length > MAX_SUBGROUPS;
    }

    get hasSubgroups() {
        return (this._group.subgroups || []).length > 0;
    }

    get hiddenGroupCount() {
        return (this._group.subgroups || []).length - MAX_SUBGROUPS;
    }

    get cssClasses() {
        return {
            'has-subgroups': this.hasSubgroups,
            'is-flatlist': this.flatlist,
        };
    }

    get group() {
        return this._group;
    }

    set group(g) {
        this._group = g;
        this.updateSubgroups();
    }

    get groupRole() {
        return this._group.role ? this._group.role.role : undefined;
    }

    public toggleSubgroups() {
        this.subgroupsOpen = !this.subgroupsOpen;

        return this.updateSubgroups();
    }

    protected updateSubgroups() {
        if (!this._group.subgroups) {
            this.subgroups = [];
            return;
        }

        if (this.subgroupsOpen) {
            this.subgroups = this._group.subgroups;
            return;
        }

        this.subgroups = this._group.subgroups.slice(0, MAX_SUBGROUPS);
    }
}

angular.module('tradersyard').component('tyGroupSidebarListItem', {
    template: `<div class="group_sidebar_list_item" ng-class="$ctrl.cssClasses" is-uib>
    <div class="group_sidebar_list_item__row">
        <a
                href="#"
                class="group_sidebar_list_item__collapse"
                ng-if="$ctrl.hasSubgroups"
                ng-click="$ctrl.isCollapsed=!$ctrl.isCollapsed; $event.preventDefault();"
        >
            <i class="fa fa-chevron-right" ng-if="$ctrl.isCollapsed"></i>
            <i class="fa fa-chevron-down" ng-if="!$ctrl.isCollapsed"></i>
        </a>
        <ty-group-sidebar-list-group search-highlight="$ctrl.filter" group="$ctrl.group"/>
        <a
                href="/group/create?parent_id={{$ctrl.group.id}}"
                ng-if="$ctrl.addButton && !$ctrl.group.parent_id && ['owner', 'executive'].includes($ctrl.groupRole)"
                uib-tooltip="Add subgroup"
                class="group_sidebar_list_item__add_subgroup">
            <i class="fa fa-plus"></i>
        </a>
    </div>
    <div class="group_sidebar_list_item__children" ng-hide="$ctrl.isCollapsed">
        <div class="group_sidebar_list_item__row"
             ng-repeat="subgroup in $ctrl.subgroups track by subgroup.id">
            <ty-group-sidebar-list-group search-highlight="$ctrl.filter" group="subgroup"/>
        </div>
        <a
                href="#"
                ng-click="$ctrl.toggleSubgroups(group); $event.preventDefault()"
                ng-if="$ctrl.subgroupsOverLimit"
                class="group_sidebar_list_item__show_more"
        >
            &mdash; {{$ctrl.subgroupsOpen ? 'show less' : 'show ' + $ctrl.hiddenGroupCount + ' more'}} &mdash;
        </a>
    </div>
</div>
    `,
    bindings: {
        group: '<',
        flatlist: '<',
        addButton: '<',
        filter: '<',
    },
    controller: GroupSidebarListItemController,
});
